import React, { Fragment } from "react";
import { Swiper } from 'swiper/react';
import SwiperCore from 'swiper/core';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-cards';
import { Autoplay, Pagination, Navigation, EffectCards } from 'swiper/modules';
SwiperCore.use([Autoplay, Pagination, Navigation, EffectCards]);

const VideoBanner = ({ children, modules, loop, centeredSlides, slidesPerView, autoplay, pagination, navigation, className, initialSlide, onSwiper, effect, grabCursor, followFinger, cardsEffect, onClick }) => {
    return (
        <Fragment>
            <div className="videoBannerWrapper">
                <Swiper
                    modules={modules ?? [Autoplay, Pagination, Navigation]}
                    loop={loop ?? false}
                    centeredSlides={centeredSlides ?? true}
                    slidesPerView={slidesPerView ?? 1}
                    autoplay={autoplay ?? {
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    pagination={pagination ?? {
                        clickable: true,
                        el: '.swiper-pagination',
                        renderBullet: (index, className) => `<span class="${className}"></span>`,
                    }}
                    navigation={navigation ?? true}
                    className={className ?? 'mySwiper carousel'}
                    initialSlide={initialSlide ?? 0}
                    onSwiper={onSwiper ?? null}
                    effect={effect ?? 'slide'}
                    grabCursor={grabCursor ?? false}
                    followFinger={followFinger ?? true}
                    cardsEffect={cardsEffect ?? {}}
                    onClick={onClick ?? null}
                    >
                    {children}
                </Swiper>
            </div>
        </Fragment>
    
  );
};

export default VideoBanner;